import React, {
    createContext,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";

import PropTypes from "prop-types";
import { IntlProvider } from "react-intl";

const TranslationContext = createContext();

const projectToken =
    process.env.REACT_APP_TRANSLATION_PROJECT ||
    "11494a5a46f54bf2a46c2767c73626b0";
const environment = process.env.REACT_APP_TRANSLATION_ENV || "_latest";

function TranslationProvider({ children }) {
    const [messages, setMessages] = useState({});
    const [translations, setTranslations] = useState([]);
    const [language, setLanguage] = useState("fr");

    const translationValue = useMemo(() => ({
        changeLanguage: (locale) => setLanguage(locale),
        language,
    }));

    useEffect(() => {
        fetch(
            `https://cdn.simplelocalize.io/${projectToken}/${environment}/_index`
        )
            .then((data) => data.json())
            .then((t) => setTranslations(t))
            .then(() =>
                fetch(
                    `${process.env.REACT_APP_LIVECHAT}/language/${window.eK.integration}`
                )
                    .then((data) => data.json())
                    .then((l) => setLanguage(l.language))
            );
    }, []);

    useEffect(() => {
        setMessages(translations[language]);
    }, [language, translations]);

    return (
        <TranslationContext.Provider value={translationValue}>
            {language && (
                <IntlProvider
                    locale={language}
                    messages={messages}
                    onError={() => {}}
                >
                    {children}
                </IntlProvider>
            )}
        </TranslationContext.Provider>
    );
}

TranslationProvider.propTypes = {
    children: PropTypes.shape(),
};

TranslationProvider.defaultProps = { children: {} };

function useTranslation() {
    const context = useContext(TranslationContext);
    if (context === undefined) {
        throw new Error(
            "useTranslation must be used within a TranslationProvider"
        );
    }
    return context;
}

export { TranslationProvider, useTranslation };
